var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyPersonalInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89px",
    height: "89px",
    viewBox: "0 0 89 89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "my-personal-info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "38.7836 37.2118 73.272 37.2118 73.272 71.6998 38.7836 71.6998"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "15 18.0005 62.7682 18.0005 62.7682 65.8625 15 65.8625"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "my-personal-info",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9938,51.2242 L40.8698,51.2242",
    id: "Stroke-1",
    stroke: "#FCBC00",
    strokeWidth: 2.657,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9938,39.318 L38.9318,39.318",
    id: "Stroke-2",
    stroke: "#FCBC00",
    strokeWidth: 2.657,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9323,40.42 L36.9323,50.104",
    id: "Stroke-3",
    stroke: "#FCBC00",
    strokeWidth: 4.894,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9323,32.715 C36.9323,31.185 38.1713,29.945 39.7023,29.945 C41.2313,29.945 42.4703,31.185 42.4703,32.715 C42.4703,34.244 41.2313,35.484 39.7023,35.484 C38.1713,35.484 36.9323,34.244 36.9323,32.715",
    id: "Fill-4",
    fill: "#FCBC00"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5046,67.9938 L42.5046,66.4078 C42.5046,64.7728 43.3586,63.2978 44.7346,62.5548 C47.4116,61.1118 51.5426,59.3938 56.0276,59.3938 C60.5136,59.3938 64.6446,61.1118 67.3206,62.5548 C68.6976,63.2978 69.5516,64.7728 69.5516,66.4078 L69.6506,67.9808 L42.5046,67.9938 Z M49.8896,47.0728 C49.8896,43.6858 52.6436,40.9318 56.0276,40.9318 C59.4126,40.9318 62.1666,43.6858 62.1666,47.0728 C62.1666,50.4568 59.4126,53.2108 56.0276,53.2108 C52.6436,53.2108 49.8896,50.4568 49.8896,47.0728 L49.8896,47.0728 Z M73.0006,64.3168 C72.6316,62.8968 71.8956,61.6128 70.8666,60.5998 C70.3446,60.0848 69.7486,59.6378 69.0866,59.2808 C66.8386,58.0698 63.6726,56.6928 60.0616,56.0468 C61.3956,55.4448 62.5666,54.5508 63.5076,53.4548 C64.5256,52.2698 65.2496,50.8388 65.6126,49.2668 C65.7756,48.5588 65.8876,47.8308 65.8876,47.0728 C65.8876,42.1528 62.2616,38.0748 57.5446,37.3408 C57.0496,37.2638 56.5456,37.2118 56.0276,37.2118 C55.1686,37.2118 54.3396,37.3338 53.5446,37.5408 C49.3096,38.6458 46.1686,42.4938 46.1686,47.0728 C46.1686,47.7988 46.2736,48.4968 46.4236,49.1788 C46.7676,50.7348 47.4706,52.1518 48.4576,53.3358 C49.4146,54.4848 50.6146,55.4238 51.9946,56.0468 C48.3846,56.6928 45.2176,58.0698 42.9696,59.2808 C42.3076,59.6378 41.7116,60.0848 41.1896,60.5998 C40.2516,61.5228 39.5726,62.6778 39.1776,63.9488 C39.1396,64.0728 39.0886,64.1908 39.0556,64.3168 C38.8816,64.9888 38.7836,65.6898 38.7836,66.4078 L38.7836,67.9488 L38.7836,67.9938 C38.7836,70.0358 40.4436,71.6978 42.5696,71.6978 L42.5736,71.6978 L69.5666,71.6998 C71.6096,71.6998 73.2726,70.0378 73.2726,67.9938 L73.2726,66.4078 C73.2726,65.6898 73.1756,64.9888 73.0006,64.3168 L73.0006,64.3168 Z",
    id: "Fill-6",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7018,55.8683 C51.5848,55.9763 51.4678,56.0853 51.3478,56.1903 C51.5788,56.1423 51.8068,56.0893 52.0428,56.0473 C51.9258,55.9943 51.8168,55.9263 51.7018,55.8683",
    id: "Fill-9",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1032,64.3165 C39.1362,64.1905 39.1872,64.0725 39.2252,63.9485 C39.6032,62.7335 40.2492,61.6285 41.1242,60.7265 C40.4042,60.8105 39.6742,60.8645 38.9322,60.8645 C28.4932,60.8645 19.9992,52.3715 19.9992,41.9315 C19.9992,31.4935 28.4932,23.0005 38.9322,23.0005 C47.7712,23.0005 55.1932,29.0975 57.2672,37.3005 C57.3752,37.3145 57.4852,37.3235 57.5922,37.3405 C59.5752,37.6495 61.3602,38.5535 62.7682,39.8585 C61.7132,27.6295 51.4292,18.0005 38.9322,18.0005 C25.7362,18.0005 14.9992,28.7355 14.9992,41.9315 C14.9992,55.1065 25.7022,65.8275 38.8682,65.8625 C38.9042,65.3365 38.9732,64.8165 39.1032,64.3165",
    id: "Fill-11",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPersonalInfo);
export default __webpack_public_path__ + "static/media/my-personal-info.8994325f88da3f1e04b0cf50558a26be.svg";
export { ForwardRef as ReactComponent };